import React from 'react';
import PropTypes from 'prop-types';

import { 
  CHECK_INTERVAL,
  REMOTE_CONTROL_INTERVAL 
} from '../../constants/timers';

export default class CommonDevice extends React.Component {
  componentDidMount() {
    this.startCheckingNewData();
    this.startSendingRemoteControl();
  }

  componentWillUnmount() {
    const serial = this.props.device.get('serial');
    clearInterval(this.intervalId);
    clearInterval(this.intervalRceId);
    this.props.setDeviceCommandValue(serial, 'setRCE', '0');
  }

  startSendingRemoteControl = () => {
    const intervalRce = REMOTE_CONTROL_INTERVAL * 1000;
    if (this.intervalRceId) {
      return;
    }
    this.sendRemoteControl();
    this.intervalRceId = window.setInterval(
      this.sendRemoteControl,
      intervalRce,
    );
  };

  startCheckingNewData = () => {
    const interval = 1000 * CHECK_INTERVAL;
    if (this.intervalId) {
      return;
    }
    this.checkForNewData();
    this.intervalId = window.setInterval(this.checkForNewData, interval);
  };

  sendRemoteControl = () => {
    const username = this.props.user.get('id');
    this.props.setDeviceCommandValue(this.props.serial, 'setRCE', username);
  };

}



// WEBPACK FOOTER //
// ./src/components/CommonDevice/Main.js